import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  insights: [
    ...(filter.insights || []),
    insights.map((insight) => ({
      type: insight.insightType as
        | 'Likes'
        | 'Dislikes'
        | 'PositiveEmotions'
        | 'NegativeEmotions'
        | 'PositiveBehaviors'
        | 'NegativeBehaviors',
      result: insight.name,
      variants: insight.variants
    }))
  ]
})

const generateSentimentInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateSentimentInsightStrategy
